jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.news-posts').length ) {

        const $ = jQuery;

        //================================================
        //                 Declarations
        //================================================


        //Filters Declarations
        var $searchBox        = $('#cs-search');
        var $categoryFilter   = $('#cs-category');
        var $dateFilter       = $('#cs-date');
        var $searchBtn        = $('#cs-search-button');


        //Container Declarations

        var $container  = $('.news-posts-container');
        var $currPage   = $('.news-posts-container').data('page');
        var $perPage    = $('.news-posts-container').data('posts_per_page');
        var $postType   = $('.news-posts-container').data('post_type');
        var $category   = $('.news-posts-container').data('category');
        var $search     = $('.news-posts-container').data('search');
        var $date       = $('.news-posts-container').data('date');


        var pageNumber = $currPage;
        var nextPageNumber = 0;


        //Load More Declaration
        var $loadMoreContainer   = $('.load-more-button-container');
        var $loadMore            = $('#load-more-news-posts');


        //================================================
        //                 Functions
        //================================================


        function checkNextNewsPage(perPage, pageNumber, category, date, search, trigger) {
            var data = {};

            sendData = {
                action: 'news_posts_ajax_handler',
                offset: pageNumber * perPage,
                per_page: perPage,
                search: search,
                category: category,
                date: date,
            };

            $.ajax({
                url: ajaxadminurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                success: function (posts) {
                    if (posts !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        trigger.show();
                    }
                },
                complete: function () {

                }
            });
        }

        function loadResults() {

            perPage = $perPage;
            search = $searchBox.val();
            category = $categoryFilter.val();
            date = $dateFilter.val();

            sendData = {
                action: 'news_posts_ajax_handler',
                offset: pageNumber * perPage,
                per_page: perPage,
                search: "",
                category: category,
                date: date,
            };

            console.log(sendData);
            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                beforeSend: function () {
                    $loadMoreContainer.hide();
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    $loadMoreContainer.remove();
                },
                success: function (data, textStatus, jqXHR) {
                    var htmlData = $.parseHTML(jqXHR.responseText);

                    $container.append(htmlData);

                    nextPageNumber = parseInt(pageNumber + 1);

                    checkNextNewsPage(perPage, nextPageNumber, category, date, search, $loadMoreContainer);

                },
                complete: function () {
                    pageNumber += 1;
                }
            });
        }


        //================================================================
        //                    Actions
        //================================================================

        $(document).on('click', '#load-more-news-posts', function () {
            loadResults();
        });

        $(document).on('change', '.news-posts-filters select', function () {
            pageNumber = 0;

            $container.attr('data_page', 1);
            $container.attr('data_date', $dateFilter.val());
            $container.attr('data-category', $categoryFilter.val());
            $container.attr('data-search', $searchBox.val());

            $container.empty();

            loadResults();

            return false;
        });


    }
});